export default "__VITE_ASSET__ClS3lOqS__"